import React from 'react'
import DocumentTitle from 'react-document-title'

import config from '../config.js'

const baseTitle = (window.document && window.document.title) || config.appName

function formatTitle (pageTitle) {
  return pageTitle ? `${pageTitle} - ${baseTitle}` : baseTitle
}

const PageTitle = (props) => <DocumentTitle title={formatTitle(props.title)}>{props.children}</DocumentTitle>

export default PageTitle



// WEBPACK FOOTER //
// ./client/src/components/PageTitle.js